import { Navigate, Route, Routes } from "react-router";

import AuthorizedRoute from "../components/Routes/AuthorizedRoutes";

import UregistrerteDetaljPage from "../components/Uregistrerte/Detalj/UregistrerteDetaljPage";
import UregistrerteKontrollerPage from "../components/Uregistrerte/Kontroller/UregistrerteKontrollerPage";

import { bypatruljen, innsyn, juridisk } from "../constants/roles";
import sitePath from "../constants/sitePaths";

const ALL = [
  ...Object.values(bypatruljen),
  ...Object.values(juridisk),
  innsyn.vaktsentralen,
  innsyn.serviceavdeling,
];

const Uregistrerte = () => (
  <Routes>
    <Route path="kontroller">
      <Route index element={<AuthorizedRoute roles={ALL}><UregistrerteKontrollerPage /></AuthorizedRoute>} />
      <Route path=":id" element={<AuthorizedRoute roles={ALL}><UregistrerteDetaljPage /></AuthorizedRoute>} />
    </Route>
    <Route index element={<Navigate to={sitePath.uregistrerte.kontroller.shortUrl} replace />} />
  </Routes>
);

export default Uregistrerte;
